import actions from './actions';
import api, { modelName } from './api';
import column from '../../abstract/column';
import vars from '../../abstract/vars';

export default {
  actions,
  api,
  modelName,
  columns: {
    id: column({ label: 'ID', primary: true, grid: false }),
    name: column({
      label: 'Nazwa',
    }),
    content: column({
      label: 'Treść',
      format: item => {
        const strippedContent = item?.content.replace(/(<([^>]+)>)/gi, '');
        return strippedContent?.length > 50 ? strippedContent?.slice(0, 50) + '...' : strippedContent || '-';
      },
    }),
  },
  vars: vars({
    noItemsText: 'Brak szablonów',
    sidebarLabel: 'Podgląd szablonu',
  }),
  topRightActions: {
    create: {
      label: 'Dodaj szablon',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push('/admin/mailing/templates/add'),
    },
  },
};
